'use strict';

(function(window, document){
	// ----------------------------------- [START] Setting
	// Window 相關設定
	var w = window,
		win = $(window),
		ww,
		wh,
		ws,
		html = document.documentElement,
		body = document.body;

	// 取得Window設定值
	var windowSetting = function () {
		ww = win.innerWidth();
		wh = win.innerHeight();
		ws = win.scrollTop();
	}
	windowSetting();
	registerListener('resize', throttle(windowSetting, 50, 100));

	// -----------------------------
	// 取得裝置判斷
	var isMobile = false,
		isTablet = false,
		isPhone = false;
	var deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true
		}
	}
	deviceDetect();
	registerListener('resize', throttle(deviceDetect, 50, 100));
	// ----------------------------------- [END] Setting

	
	// -------------------------------------
	// Click & Keyborad

	var dropdownSelect = $('.dropdown-select');
	var dropdownList = dropdownSelect.parent().children('.nav-list');
	var dropdownCurrent = null;
	var selectDefault = null;
	var selectCurrent;
	var dropdownSelectActiveClasss = 'is-active';


	// SmoothScroll
	$('[data-scroll-smooth]').on('click', function(){
		var rate = (isPhone) ? 2 : 1.5;
		$('html, body').animate({'scrollTop': $(this.hash).offset().top - headerH * rate}, 500)
	});

	// Page Ready Change Text
	$('.dropdown-box').each(function(){
		var currentItem = $(this);
		var active = currentItem.find('.'+dropdownSelectActiveClasss);
		if(active != undefined && active.length > 0){
			currentItem.children('.dropdown-select').text(currentItem.find('.'+dropdownSelectActiveClasss).text());
		}
	})

	// Dropdown
	dropdownSelect.on('click', function(){
		// 如果點擊到其它DropdownSelect
		if(dropdownCurrent != null && dropdownCurrent != this){
			dropdownCurrent.classList.remove('is-open')
		}
		dropdownCurrent = this;
		this.classList.toggle('is-open');
		if(!this.classList.contains('is-open')){
			this.blur();
			dropdownCurrent = null;
			selectDefault = null;
		};
		documentClickDetected();
	}).on('focus', function(){
		if(dropdownCurrent != null){
			dropdownCurrent.classList.remove('is-open')
		}
		// Dropdown Select Focus : if computer => keyboard Listener
		dropdownCurrent = this;
		if(!isMobile){
			window.addEventListener('keyup', dropdownKeyboard, false);

			// Disable Scroll
			disableScroll();
		}
	});

	// Dropdown list
	dropdownList.on('click', 'a', function(){
		var item = $(this);
		var itemParent = item.parent().parent(); // UL
		item.blur();

		// Add Active Style
		itemParent.find('.'+dropdownSelectActiveClasss).removeClass(dropdownSelectActiveClasss);
		item.addClass(dropdownSelectActiveClasss);

		// Change Text
		$(item.parentsUntil('.nav-list')[item.parentsUntil('.nav-list').length - 1].parentElement.parentElement).children('.dropdown-select').text(item.text());

		// Close Select
		dropdownSelect.removeClass('is-open');
		documentClickDetected();
	}).on('focus', 'a', function(){
		if(!isMobile){
			// 造成點擊後無法換頁的狀況，因為增加is-open
			// 原本是為了配合鍵盤Tab，但這樣看起來無法使用，先註解
			// $(this).closest('.nav-list').parent().children('.dropdown-select').addClass('is-open'); //Select<a>
			
			documentClickDetected();

			// Disable Scroll
			// docDisableScroll();

			// Fixed IE can't use :focus-within
			if(document.documentElement.browser === 'IE'){
				dropdownList.addClass('focus-within');
			}
			
		}
	}).on('focusout', 'a', function(){
		if(!isMobile){
			// Fixed IE can't use :focus-within
			if(document.documentElement.browser === 'IE'){
				dropdownList.removeClass('focus-within');
			}
		}
	});
	

	// Add Listener
	function documentClickDetected(){
		if(isMobile){
			// Mobile
			if(dropdownSelect.hasClass('is-open')){
				setTimeout(function(){
					document.addEventListener('touchend', dropdownClickHandaler, true);
				},500);
			}
		}else{
			// PC
			if(dropdownSelect.hasClass('is-open')){
				// Keyboard
				window.addEventListener('keyup', dropdownKeyboard, false);

				// Click
				setTimeout(function(){
					document.addEventListener('click', dropdownClickHandaler, true);
				},500);
			}
		}
	}
	function dropdownClickHandaler(event){
		var isList = $(event.target).parents('.dropdown-box').length > 0;
		if(!isList){
			event.preventDefault();
			dropdownClose();
		}
	}

	function dropdownClose(){
		dropdownCurrent = null;
		selectDefault = null;
		dropdownSelect.removeClass('is-open');
		dropdownSelect.blur();
		dropdownList.find('a').blur();

		// 停止EventLitener
		document.removeEventListener('touchend', dropdownClickHandaler, true);
		document.removeEventListener('click', dropdownClickHandaler, true);
		window.removeEventListener('keyup', dropdownKeyboard, false);

		docEnableScroll();
	}


	var keyControlDirArray = [33,34,35,36,38,40];
	// Page Up, Page Down, End, Home, Up, Down
					
	function dropdownKeyboard(event){
		var key = event.keyCode;
		if(key === 27){
			dropdownClose();
		}else if(keyControlDirArray.includes(key)){
			changeSelect(key);
		}
	}

	// Fixed IE Bug: IE does not support 'includes' method
	// https://stackoverflow.com/a/39744409
	if (!Array.prototype.includes) {
		Object.defineProperty(Array.prototype, "includes", {
			enumerable: false,
			value: function(obj) {
				var newArr = this.filter(function(el) {
					return el == obj;
				});
				return newArr.length > 0;
			}
		});
	}

	function changeSelect(key){
		if(dropdownCurrent != null || dropdownCurrent != undefined){
			
			var target = $(dropdownCurrent).parent().children('.nav-list');
			var targetList = target.find('li');
			var selectLen = targetList.length;
			// 確認Active
			if(selectDefault === null){
				selectDefault = targetList.find('.'+dropdownSelectActiveClasss).parent().index();
				selectCurrent = selectDefault;
			}

			switch(key){
				case 38:
					// Up
					selectCurrent = (selectCurrent == 0) ? 0 : selectCurrent - 1;
					break;
				case 40:
					// Down
					selectCurrent = (selectCurrent == selectLen - 1) ? selectLen - 1 : selectCurrent + 1;
					break;
				case 33:
					// Page Up
					selectCurrent = (selectCurrent - 4 < 0) ? 0 : selectCurrent - 4;
					break;
				case 34:
					// Page Down
					selectCurrent = (selectCurrent + 4 > selectLen - 1) ? selectLen - 1 : selectCurrent + 4;
					break;
				case 35:
					// End
					selectCurrent = selectLen - 1;
					break;
				case 36:
					// Home
					selectCurrent = 0;
					break;
			}

			// Change Active Class
			var currentItem = targetList.eq(selectCurrent).children('a');
			// targetList.find('.'+dropdownSelectActiveClasss).removeClass(dropdownSelectActiveClasss);
			// currentItem.addClass(dropdownSelectActiveClasss);
			currentItem.focus();

			
			// Change Scroll
			// 超出可視範圍
			var scroll_content = target.find('.simplebar-scroll-content') || target; // 因為有使用simplebar的關係，所以ScrollTop控制的對象更改
			var scroll_contentH = target.innerHeight(); //因為simplebar-scroll-content不明原因增加margin-bottom，所以更改對象為 
			var scroll_list_HasScroll = scroll_content.hasScrollBar();
			
			if(!isMobile && scroll_list_HasScroll){
				var currentOffsetTop = currentItem.parent().get(0).offsetTop;
				if(scroll_content.scrollTop() > currentOffsetTop){
					// 小於可視範圍
					// 因為有用easeScroll的關係Scroll速度被拖慢
					scroll_content.stop().animate({'scrollTop': currentOffsetTop}, 20, 'linear');
				}else if(scroll_contentH + scroll_content.scrollTop() < currentOffsetTop + currentItem.innerHeight()){
					// 大於可視範圍
					scroll_content.stop().animate({'scrollTop': currentOffsetTop + currentItem.innerHeight() - scroll_contentH}, 20, 'linear');
				}
			}
		}
	}

	// -------------------------------------
	// setting 商品明細開合樣式
	function clickPdList(){
		$(".toggle_detail").each(function(index) {
			$(this).on("click", function(){
				$(this).toggleClass('visited');
			});
		});
	}
	clickPdList();

	// ----------------------------------- [START] Store List Nav Scroll
	// Store List Nav Scroll
	function storeNavScroll(){
		var storeNav = $('.tab-nav ul');
		if(storeNav.length > 0) {
			var storeNavActive = storeNav.find('.active');
			var storeNavLeft = storeNavActive.get(0).offsetLeft;
			storeNav.stop().animate({'scrollLeft': storeNavLeft});
		}
	}
	registerListener('load', storeNavScroll);
	// ----------------------------------- [END] Store List Nav Scroll
})(window, document);

(function(H){
	H.className=H.className.replace(/\bno-js\b/,'js')
})(document.documentElement);

